import React, { useEffect } from 'react';
import { EventEmitter } from 'events';
import { KView } from '@/component/RtlLayout';

const touchEvent = new EventEmitter();

const TOUCH_EVENT_NAMES = {
    VIEW_TOUCH_START: 'wrappered_view_touch_start',
    VIEW_TOUCH_END: 'wrappered_view_touch_end',
    VIEW_REMOVE_LOOP: 'wrappered_view_remove_loop',
};

const withGlobalTouchStart = (WrappedComponent: any) => {
    const WithTouchEventEmitter = (props = {}) => {
        const handleTouchStart = () => {
            touchEvent.emit(TOUCH_EVENT_NAMES.VIEW_TOUCH_START, { time: Date.now() });
        };

        const handleTouchEnd = () => {
            touchEvent.emit(TOUCH_EVENT_NAMES.VIEW_TOUCH_END, { time: Date.now() });
        };

        useEffect(() => {
            return () => {
                touchEvent.emit(TOUCH_EVENT_NAMES.VIEW_REMOVE_LOOP);
                touchEvent.removeAllListeners(TOUCH_EVENT_NAMES.VIEW_TOUCH_START);
                touchEvent.removeAllListeners(TOUCH_EVENT_NAMES.VIEW_TOUCH_END);
            };
        }, []);

        return (
            <KView
                style={{
                    width: '100%',
                    height: '100%',
                }}
                onTouchStart={handleTouchStart}
                onTouchEnd={handleTouchEnd}
                onTouchCancel={handleTouchEnd}
            >
                <WrappedComponent {...props} />
            </KView>
        );
    };

    return WithTouchEventEmitter;
};

export default withGlobalTouchStart;

export { touchEvent, TOUCH_EVENT_NAMES };
